import React from 'react';
import { Progress } from 'semantic-ui-react';
import styles from './diagram.css';
import { getSwitchClassNameOrColourWithBackground } from '../../../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly calendar?: *, readonly dontShowProgress?: *, readonly wrapStyle?: *, readonly style?: *, readonly data?: *}>}
 */
const Diagram = React.memo( ( { style, calendar, data, wrapStyle, dontShowProgress } ) => {

    const background = calendar.settings.appearance.inner_background ? calendar.settings.appearance.inner_background : 'rgba(0, 0, 0, .5)';
    const textAutoColorClass = getSwitchClassNameOrColourWithBackground( background, 'lightBgPlaceholder', 'darkBgPlaceholder' );
    const diagrammData = [];

    for ( let key in data ) {
        diagrammData.push( { key: data[ key ].answers[ 0 ].question_text, data: data[ key ].answers } );
    }

    return (
        diagrammData && ( diagrammData.length > 0 ) ?
            <div style={ { ...wrapStyle } } className={ styles.wrapper }>

                { diagrammData.map( ( el ) => {

                    return ( <div>
                        <h4 className={ `${ styles[ textAutoColorClass ] }` } style={ { ...style } }> { el?.key }</h4>
                        { el.data.map( ( el, i ) => {
                            const { percent } = el;
                            const calcProcent = percent.toFixed( 2 );
                            return (
                                <div className={ styles.wrapperItem } key={ i }>
                                    <div className={ `${ styles.itemText } ${ styles[ textAutoColorClass ] }` }>
                                        <p className={ `${ styles.text } ${ styles[ textAutoColorClass ] }` }>{ el?.answer?.text }</p>
                                        <p className={ `${ styles.answersPercent } ${ styles[ textAutoColorClass ] }` }>
                                            { `${ calcProcent } %` }
                                        </p>
                                    </div>
                                    { !dontShowProgress &&
                                    <Progress className={ styles.itemProgress } percent={ calcProcent } size='small'/> }
                                </div>
                            );
                        } ) }
                    </div> );

                } ) }

            </div> :
            <div className={ styles.messageWrapper }><h4 style={ { ...style } }> We don't have statistics at the
                moment. </h4></div>
    );
} );

export default Diagram;